import React from "react";
import { connect } from "react-redux";
import { FiCheckCircle, FiDownload, FiRefreshCw, FiX } from "react-icons/fi";
import { appActions } from "../../../redux/actions/in-app";
import { appConstants } from "../../../redux/action-constants/inapp.constants";
import "./index.scss";

interface CustomerExportToastProps {
  exportState: any;
  startExport: any;
  cancelExport: any;
  resetExport: any;
}

const CustomerExportToast: React.FC<CustomerExportToastProps> = ({
  exportState,
  startExport,
  cancelExport,
  resetExport,
}) => {
  const status = exportState?.request_status;
  const data = exportState?.request_data || {};
  const isVisible =
    status &&
    status !== appConstants.EXPORT_CUSTOMERS_CSV_RESET &&
    status !== appConstants.EXPORT_CUSTOMERS_CSV_CANCEL;

  if (!isVisible) return null;

  const isFailed = status === appConstants.EXPORT_CUSTOMERS_CSV_FAILURE;
  const isSuccess = status === appConstants.EXPORT_CUSTOMERS_CSV_SUCCESS;
  const isProcessing = exportState?.is_request_processing;
  const percent = Math.max(0, Math.min(100, data.percent || 0));

  const handleRetry = () => {
    if (data.exportRequest) {
      startExport(data.exportRequest);
    }
  };

  return (
    <div className={`customer-export-toast ${isFailed ? "failed" : ""}`}>
      <div className="export-toast-icon">
        {isSuccess ? <FiCheckCircle /> : <FiDownload />}
      </div>

      <div className="export-toast-content">
        <div className="export-toast-heading">
          {isSuccess
            ? "Customer CSV ready"
            : isFailed
              ? "Customer CSV failed"
              : "Exporting customers"}
        </div>
        <div className="export-toast-message">
          {isFailed
            ? data.error || "CSV conversion failed. Please try again."
            : data.message}
        </div>

        {!isFailed && (
          <div className="export-toast-progress">
            <div className="progress-track">
              <div className="progress-fill" style={{ width: `${percent}%` }} />
            </div>
            <span>{percent}%</span>
          </div>
        )}
      </div>

      <div className="export-toast-actions">
        {isFailed && (
          <button className="toast-action-btn" onClick={handleRetry}>
            <FiRefreshCw />
            Retry
          </button>
        )}
        {isProcessing && (
          <button className="toast-icon-btn" onClick={cancelExport} aria-label="Cancel export">
            <FiX />
          </button>
        )}
        {!isProcessing && (
          <button className="toast-icon-btn" onClick={resetExport} aria-label="Dismiss export status">
            <FiX />
          </button>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  exportState: state.allInAppReducers.customerCsvExportReducer,
});

const mapDispatchToProps = {
  startExport: appActions.StartCustomerCsvExport,
  cancelExport: appActions.CancelCustomerCsvExport,
  resetExport: appActions.ResetCustomerCsvExport,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerExportToast);
